import React from "react";

import GerenciarParametros from "./gerenciarParametros";
import GerenciarRecebiveis from "./gerenciarRecebiveis";
import GerenciarGrupos from "./gerenciarGrupos";

export default function Parametros() {
    return (
        <div className="flex flex-col gap-4 overflow-x-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
                <div className="lg:col-span-7 flex flex-col gap-4">
                    <GerenciarRecebiveis />
                    <GerenciarGrupos />
                </div>
                <div className="lg:col-span-5">
                    <GerenciarParametros />
                </div>
            </div>
        </div>
    );
}
